<div class="main-box">
    <div [formGroup]="templateForm" *ngIf="templateForm" class="main-container">
      <a (click)="backToTemplateList()">
        <p>back to list</p>
      </a>
      <table>
        <tr>
            <td>
                Template name*
              </td>
              <td>
                  <input pInputText placeholder="Name" type="text" formControlName="name">
              </td>
        </tr>
        <tr>
          <td>Template category*</td>
          <td>
            <p-dropdown placeholder="Select category" formControlName="category" [options]="categories"
              optionLabel="name"></p-dropdown>
          </td>
        </tr>
        <tr>
          <td>
            Type
          </td>
          <td>
            <p-radioButton name="documentTypeId" label="for Student" [value]="1" formControlName="documentTypeId"></p-radioButton>
            <p-radioButton name="documentTypeId" label="for School" [value]="2" formControlName="documentTypeId"></p-radioButton>
          </td>
        </tr>
        <tr>
          <td>
            Language*
          </td>
          <td>
            <p-dropdown placeholder="Select Language" formControlName="language" [options]="languages" optionLabel="name"></p-dropdown>
          </td>
        </tr>
        <tr>
          <td>
            Content
          </td>
          <td>
            <ckeditor [editor]="Editor" *ngIf="!advancedEditor" formControlName="body"></ckeditor>
              <textarea #textArea *ngIf="advancedEditor" class="raw-editor" formControlName="body"></textarea>
          </td>
        </tr>
      </table>
      <div>
        <p-button label="Submit" (onClick)="sendForm()" class="submit-button"></p-button>
        <p-button [label]="advancedEditor?'Visual Editor':'Advanced Editor'" (onClick)="activateAdvanced()"></p-button>
      </div>
      </div>
      <div>
        <div *ngFor="let field of pdfService.availableFields" (click)="insertFieldValue(field)" class="custom-fields">
          {{field.label}}
        </div>
      </div>
</div>